import { Action } from 'redux';

export enum ViewTreeTypes {
  LOAD_VIEW_TREE = 'view_tree/load',
  LOADING_VIEW_TREE = 'view_tree/loading',
  LOADED_VIEW_TREE = 'view_tree/loaded',
  LOADING_VIEW_TREE_FAILED = 'view_tree/loading-failed',
}

export type NodePath = number[];

export interface ILoad extends Action {
  type: ViewTreeTypes.LOAD_VIEW_TREE;
  payload: string;
}

export interface ILoading extends Action {
  type: ViewTreeTypes.LOADING_VIEW_TREE;
}

export interface ILoaded extends Action {
  type: ViewTreeTypes.LOADED_VIEW_TREE;
  payload: any;
}

export interface ILoadingFailed extends Action {
  type: ViewTreeTypes.LOADING_VIEW_TREE_FAILED;
}

// Functions

export function load(type: string): ILoad {
  return {
    type: ViewTreeTypes.LOAD_VIEW_TREE,
    payload: type
  }
}

export function loading(): ILoading {
  return {
    type: ViewTreeTypes.LOADING_VIEW_TREE
  }
}

export function loaded(result: any): ILoaded {
  return {
    type: ViewTreeTypes.LOADED_VIEW_TREE,
    payload: result
  }
}

export function loadingFailed(): ILoadingFailed {
  return {
    type: ViewTreeTypes.LOADING_VIEW_TREE_FAILED
  }
}

export type ViewTreeAction =
  ILoad |
  ILoading |
  ILoaded |
  ILoadingFailed;
